import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"position":"absolute","left":"0","top":"0","height":"100%","width":"100%","display":"inline-block","box-sizing":"border-box","padding":"0 20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["el-menu-item", {
      'is-active': _ctx.active,
      'is-disabled': _ctx.disabled
    }]),
    role: "menuitem",
    tabindex: "-1",
    style: _normalizeStyle([_ctx.paddingStyle, _ctx.itemStyle, { backgroundColor: _ctx.backgroundColor }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
    onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
    onFocus: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMouseEnter && _ctx.onMouseEnter(...args))),
    onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args))),
    onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args)))
  }, [
    (_ctx.parentMenu.type.name === 'ElMenu' && _ctx.rootMenu.props.collapse && _ctx.slots.title)
      ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          effect: _ctx.Effect.DARK,
          placement: "right"
        }, {
          content: _withCtx(() => [
            _renderSlot(_ctx.$slots, "title")
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 3
        }, 8, ["effect"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _renderSlot(_ctx.$slots, "default"),
          _renderSlot(_ctx.$slots, "title")
        ], 64))
  ], 38))
}